import { gql } from '@apollo/client';

export const GET_USER_MESSAGES = gql`
  query GetUserMessages($friend_id: String!, $conversation_id: Int!) {
    userMessages(friend_id: $friend_id, conversation_id: $conversation_id) {
      id
      uuid
      message
      sender_id
      receiver_id
      conversation_id
      sender {
        id
        name
        avatar {
          thumb
        }
      }
      receiver {
        id
        name
        avatar {
          thumb
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_GROUP_MESSAGES = gql`
  query GetGroupMessages($groupChatId: ID!, $first: Int!, $after: String) {
    groupMessages(groupChatId: $groupChatId, first: $first, after: $after) {
      edges {
        node {
          id
          uuid
          message
          type
          sender {
            id
            name
            avatar {
              thumb
            }
          }
          metadata
          createdAt
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  # query GetGroupMessages($groupChatId: ID!) {
  #   groupMessages(groupChatId: $groupChatId) {
  #     id
  #     uuid
  #     message
  #     type
  #     sender {
  #       id
  #       name
  #       avatar {
  #         thumb
  #       }
  #     }
  #     metadata
  #     createdAt
  #   }
  # }
`;

export const GET_CONVERSATIONS = gql`
  query {
    userConversations {
      id
      user {
        id
        name
        email
        avatar {
          name
          path
          placeholder
          thumb
        }
      }
      friend {
        id
        name
        email
        avatar {
          name
          path
          placeholder
          thumb
        }
      }
      updatedAt
      last_message {
        id
        message
        sender_id
        createdAt
      }
      unread_count
    }
  }
`;

export const MESSAGES_QUERY = gql`
  query ($conversationId: Int!) {
    conversationMessages(conversation_id: $conversationId) {
      id
      message
      sender_id
      receiver_id
      conversation_id
      created_at
      updated_at
      sender {
        id
        name
        avatar {
          thumb
        }
      }
      receiver {
        id
        name
        avatar {
          thumb
        }
      }
    }
  }
`;
